import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShowQrcode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 6C32.552 6 33 6.448 33 7C33 7.552 32.552 8 32 8C31.448 8 31 7.552 31 7C31 6.448 31.448 6 32 6Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 9C32.552 9 33 9.448 33 10C33 10.552 32.552 11 32 11C31.448 11 31 10.552 31 10C31 9.448 31.448 9 32 9Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 12C32.552 12 33 12.448 33 13C33 13.552 32.552 14 32 14C31.448 14 31 13.552 31 13C31 12.448 31.448 12 32 12Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 3C29.552 3 30 3.448 30 4C30 4.552 29.552 5 29 5C28.448 5 28 4.552 28 4C28 3.448 28.448 3 29 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 3C26.552 3 27 3.448 27 4C27 4.552 26.552 5 26 5C25.448 5 25 4.552 25 4C25 3.448 25.448 3 26 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 3C23.552 3 24 3.448 24 4C24 4.552 23.552 5 23 5C22.448 5 22 4.552 22 4C22 3.448 22.448 3 23 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 3C10.552 3 11 3.448 11 4C11 4.552 10.552 5 10 5C9.448 5 9 4.552 9 4C9 3.448 9.448 3 10 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 3C13.552 3 14 3.448 14 4C14 4.552 13.552 5 13 5C12.448 5 12 4.552 12 4C12 3.448 12.448 3 13 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 3C7.552 3 8 3.448 8 4C8 4.552 7.552 5 7 5C6.448 5 6 4.552 6 4C6 3.448 6.448 3 7 3Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 6C4.552 6 5 6.448 5 7C5 7.552 4.552 8 4 8C3.448 8 3 7.552 3 7C3 6.448 3.448 6 4 6Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9C4.552 9 5 9.448 5 10C5 10.552 4.552 11 4 11C3.448 11 3 10.552 3 10C3 9.448 3.448 9 4 9Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 12C4.552 12 5 12.448 5 13C5 13.552 4.552 14 4 14C3.448 14 3 13.552 3 13C3 12.448 3.448 12 4 12Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 25C32.552 25 33 25.448 33 26C33 26.552 32.552 27 32 27C31.448 27 31 26.552 31 26C31 25.448 31.448 25 32 25Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 22C32.552 22 33 22.448 33 23C33 23.552 32.552 24 32 24C31.448 24 31 23.552 31 23C31 22.448 31.448 22 32 22Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 28C32.552 28 33 28.448 33 29C33 29.552 32.552 30 32 30C31.448 30 31 29.552 31 29C31 28.448 31.448 28 32 28Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 31C29.552 31 30 31.448 30 32C30 32.552 29.552 33 29 33C28.448 33 28 32.552 28 32C28 31.448 28.448 31 29 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 31C26.552 31 27 31.448 27 32C27 32.552 26.552 33 26 33C25.448 33 25 32.552 25 32C25 31.448 25.448 31 26 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 31C23.552 31 24 31.448 24 32C24 32.552 23.552 33 23 33C22.448 33 22 32.552 22 32C22 31.448 22.448 31 23 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 31C10.552 31 11 31.448 11 32C11 32.552 10.552 33 10 33C9.448 33 9 32.552 9 32C9 31.448 9.448 31 10 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 31C13.552 31 14 31.448 14 32C14 32.552 13.552 33 13 33C12.448 33 12 32.552 12 32C12 31.448 12.448 31 13 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 31C7.552 31 8 31.448 8 32C8 32.552 7.552 33 7 33C6.448 33 6 32.552 6 32C6 31.448 6.448 31 7 31Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 25C4.552 25 5 25.448 5 26C5 26.552 4.552 27 4 27C3.448 27 3 26.552 3 26C3 25.448 3.448 25 4 25Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 22C4.552 22 5 22.448 5 23C5 23.552 4.552 24 4 24C3.448 24 3 23.552 3 23C3 22.448 3.448 22 4 22Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 28C4.552 28 5 28.448 5 29C5 29.552 4.552 30 4 30C3.448 30 3 29.552 3 29C3 28.448 3.448 28 4 28Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 17C23.552 17 24 17.448 24 18C24 18.552 23.552 19 23 19C22.448 19 22 18.552 22 18C22 17.448 22.448 17 23 17Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 20C23.552 20 24 20.448 24 21C24 21.552 23.552 22 23 22C22.448 22 22 21.552 22 21C22 20.448 22.448 20 23 20Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 22C21.552 22 22 22.448 22 23C22 23.552 21.552 24 21 24C20.448 24 20 23.552 20 23C20 22.448 20.448 22 21 22Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 22C15.552 22 16 22.448 16 23C16 23.552 15.552 24 15 24C14.448 24 14 23.552 14 23C14 22.448 14.448 22 15 22Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12C15.552 12 16 12.448 16 13C16 13.552 15.552 14 15 14C14.448 14 14 13.552 14 13C14 12.448 14.448 12 15 12Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12C21.552 12 22 12.448 22 13C22 13.552 21.552 14 21 14C20.448 14 20 13.552 20 13C20 12.448 20.448 12 21 12Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 14C23.552 14 24 14.448 24 15C24 15.552 23.552 16 23 16C22.448 16 22 15.552 22 15C22 14.448 22.448 14 23 14Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 12C18.552 12 19 12.448 19 13C19 13.552 18.552 14 18 14C17.448 14 17 13.552 17 13C17 12.448 17.448 12 18 12Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22C18.552 22 19 22.448 19 23C19 23.552 18.552 24 18 24C17.448 24 17 23.552 17 23C17 22.448 17.448 22 18 22Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 14C13.552 14 14 14.448 14 15C14 15.552 13.552 16 13 16C12.448 16 12 15.552 12 15C12 14.448 12.448 14 13 14Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 17C13.552 17 14 17.448 14 18C14 18.552 13.552 19 13 19C12.448 19 12 18.552 12 18C12 17.448 12.448 17 13 17Z",
			fill: "var(--color-blue-500)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 20C13.552 20 14 20.448 14 21C14 21.552 13.552 22 13 22C12.448 22 12 21.552 12 21C12 20.448 12.448 20 13 20Z",
			fill: "var(--color-blue-500)"
		})
	]
});
export default SvgShowQrcode;
